import type { JSX } from 'react';
import { cn } from '@/lib/utils';
import type { FolderCounts } from '../api/types';
import { folderProgress, progressLegend } from './progress';

/** Where a folder's leads stand, as one stacked bar with a legend underneath. */
export function FolderProgressBar({ counts, className }: { counts: FolderCounts | null | undefined; className?: string }): JSX.Element | null {
  const p = folderProgress(counts);
  if (p.total === 0) return null;
  const legend = progressLegend(counts);
  return (
    <div className={cn('space-y-1.5', className)}>
      <div
        className="flex h-2 overflow-hidden rounded-full bg-muted"
        role="img"
        aria-label={`${p.donePct}% done. ${legend.map((l) => `${l.label}: ${l.count}`).join(', ')}`}
      >
        {p.segments.map((s) => (
          <span key={s.key} className={cn('h-full', s.swatch)} style={{ width: `${s.pct}%` }} title={`${s.label}: ${s.count.toLocaleString()}`} />
        ))}
      </div>
      <ul className="flex flex-wrap gap-x-4 gap-y-1 text-sm text-muted-foreground">
        {legend.map((l) => (
          <li key={l.label} className="inline-flex items-center gap-1.5">
            <span aria-hidden className={cn('h-2 w-2 rounded-full', l.swatch)} />
            {l.label}
            <span className="tabular-nums text-foreground">{l.count.toLocaleString()}</span>
          </li>
        ))}
        <li className="ml-auto tabular-nums">{p.donePct}% done</li>
      </ul>
    </div>
  );
}
